/* eslint react-hooks/exhaustive-deps: "warn" */

import cn from 'classnames';

import { TitleBlock } from 'ui/atoms/TitleBlock/TitleBlock';

import styles from './IndexSection.module.scss';

import type { IndexSectionProps } from './IndexSection.types';

export const IndexSection = ({ id, title, aside, className, children }: IndexSectionProps) => (
  <section id={id} className={cn(styles['section'], className)}>
    <div className={styles['inner']}>
      <div className={styles['head']}>
        <TitleBlock align="left" accent="none" title={title} className={styles['heading']} />

        {aside && <div className={styles['aside']}>{aside}</div>}
      </div>

      {children}
    </div>
  </section>
);
